<style scoped lang="scss">
  @import "../user";
  @import "./ipone";
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">Fast NGS订单</h3>
      <div class="search-form">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="关联用户：" v-if="isHeadMan">
              <el-select v-model="searchForm.customerId" filterable clearable>
                  <el-option
                          v-for="item in courseInfo.members"
                          :key="item.id"
                          :label="item.realName"
                          :value="item.id">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="客户备注：">
            <el-input v-model="searchForm.customerRemark" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="时间：" class="date">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="bindSearch" class="search-button">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="d-flex flex-align-center">
            <div class="flex-1">
                订单状态：
                <el-radio-group v-model="status" @change="getOrders">
                    <el-radio label="">全部</el-radio>
                    <el-radio label="ING">进行中</el-radio>
                    <el-radio label="OK">已完成</el-radio>
                </el-radio-group>
            </div>
            <el-button type="primary" @click="bindDownLoad" class="sanger_button">结果下载</el-button>
            <el-button type="primary" @click="getDetailsExcel" class="sanger_button">明细表下载</el-button>
       </div>
      </div>      
      <el-table
        class="mt20"
        border
         v-loading="loading"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          label="订单编号"
          width="245px">
          <template slot-scope="scope">
            <router-link :to="`/user/fastNGS_details?id=${scope.row.value.id}`">{{scope.row.value.no}}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerRemark"
          width="90px"
          label="客户备注">
           <template slot-scope="scope">{{scope.row.value.customerRemark ||''}}</template>
        </el-table-column>
        <el-table-column
          prop="date"
          label="下单时间"
          width="160px">
          <template slot-scope="scope">{{scope.row.value.createTime | rTime}}</template>
        </el-table-column>
        <el-table-column
          prop="totalNum"
          width="90px"
          label="反应总数">
        </el-table-column>
        <el-table-column
          prop="okNum"
          width="90px"
          label="成功数">
        </el-table-column>
        <el-table-column
          v-if="isHeadMan"
          prop="customerName"
          label="关联用户">
        </el-table-column>
        <el-table-column
          width="120px"
          label="订单金额（元）">
          <template slot-scope="scope">{{scope.row.value.settlementAmount | amount}}</template>
        </el-table-column>
        <el-table-column
          prop="value.orderStatusName"
          label="订单状态">
        </el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          :total="total"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { highOrders,highOrdersWorderDocK,highOrdersExcel } from '@/services/api.index'
import { showLoading, hideLoading } from './loading'
export default {
  data() {
    return {
      loading: false,
      searchForm: {
        orderNo: '',
        customerId: '',
        customerRemark:'',
        date: null,
      },
      status: '',
      multipleSelection:[],
      tableData: [],
      orderTable:[],
      loading:false,
      selectedIds:[],
      selectedId1:[],
      selectedId2:[],
      reactionLists:[],
      reactionTotal: 0,
      total: 0,
      page: 0,
      reactionPage: 0,
      reactionSize: 10,
      pageSize: 10,
      isHeadMan: this.baseMethods.isHeadMan(),
      courseInfo: this.baseMethods.getLocalObj('courseInfo'),
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now() - 8.64e6 // 如果没有后面的-8.64e6就是不可以选择今天的
          return (
                  time.getTime() < new Date("2000-1-1").getTime() ||
                  time.getTime() > new Date("2100-1-1").getTime()
                );
        }
      }
    }
  },
  created() {
    this.getOrders();
  },
  methods: {
    getOrders () {
      this.loading = true
      const { page, pageSize, status } = this
      let { orderNo, date, customerId,customerRemark} = this.searchForm
      date = date || ['', '']
      const searchIds = this.baseMethods.getSearchId(customerId)
      highOrders(page, pageSize, orderNo, ...date, status, ...searchIds,customerRemark).then(res => {
        res.data.list.map(item => {
          item.value.orderStatusName = this.baseMethods.orderStatus(item.userWebOrderStatus)
        })
        this.tableData = res.data.list
        console.log('*****8')
        console.log(this.tableData)
        this.total = res.data.totalCount
      }).finally(() => {
        this.loading = false
      })
    },
    getDetailsExcel() {      
      if (this.selectedIds.length==0) {
        this.$message.warning("请选择一个订单进行下载");
        return;
      }
      showLoading();
      setTimeout(() => {
        highOrdersExcel({"orderIds":this.selectedIds}).then((res) => {
          this.baseMethods.downloadFile(res.data, "Fast NGS明细表");
        }).finally(()=>{
              hideLoading(); 
        });;
      }, 2000);
    },
    bindSearch () {
      this.page = 0;
      this.getOrders();
    },    
    // 反应信息多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.selectedIds = val.map((v) => v.value.id);
      this.selectedId1 = val.map((v) => v.okNum);//实际反应成功数
      this.selectedId2 = val.map((v) => v.totalNum);//实际反应数     
    },
    // 下载
    bindDownLoad(){
      let multipleSelection=this.multipleSelection;
       if(multipleSelection.length===0){
        return this.$message.warning("请选择需要下载的订单");
       }
       if(multipleSelection){
          let ids=multipleSelection.map(item=>item.value.id);
          showLoading();          
          highOrdersWorderDocK({"orderIds":ids}).then((res) => {           
                let date= this.baseMethods.formatDate(new Date()).join('-');                  
                this.baseMethods.downloadFile(
                  res.data,
                  `结果文件${date}`,
                  "doc"
                );
            }).finally(()=>{
              hideLoading(); 
            });
       }
       
    },
    
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getOrders();
    }
  }
}
</script>
<style>
@import "loading.css";
</style>
<style>
.el-loading-parent--relative{
  overflow: auto!important;
}
</style>


// WEBPACK FOOTER //
// src/views/user/children/fastNGS.vue